import { useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { AuthService } from "../../services/authService";
import { useLocation} from "react-router-dom";

const ResendEmailResetForm = () => {
  const [submitting, setSubmitting] = useState(false);
  const [email, setEmail] = useState("");
  const location = useLocation();
  const toastRef = useRef<Toast | null>(null);
  const [timer, setTimer] = useState(30);
  const [resendEnabled, setResendEnabled] = useState(false);


  useEffect(() => {
    const state = location.state as { email: string | null };
    if (state?.email) {
      setEmail(state.email);
    }
  }, [location.state]); 

  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => setTimer((prevTimer) => prevTimer - 1), 1000);
      return () => clearInterval(interval);
    } else {
      setResendEnabled(true);
    }
  }, [timer]);

  const resendEmail = async () => {
    setSubmitting(true);
    try {
      const result = await AuthService.sendEmailResetPassword(email);
      if (result && result.statusCode === 2000) {
        toastRef.current?.show({
          severity: "success",
          summary: "Email Sent",
          detail: result.message,
          life: 3000,
        });
      } else {
        toastRef.current?.show({
          severity: "error",
          summary: "Error",
          detail: result.message,
          life: 3000,
        });
      }
    } catch (error) {
      toastRef.current?.show({
        severity: "error",
        summary: "Error",
        detail: "An error occurred while resending the email.",
        life: 3000,
      });
    } finally {
      setSubmitting(false);
      setTimer(30);
      setResendEnabled(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center">
      
      <div className="mt-5 icon-container mb-6 flex justify-center items-center">
            <i className="pi pi-envelope text-black text-5xl p-8 bg-gray-300 rounded-full"></i>
             <Toast ref={toastRef} className="toast-top-center" />
        </div>
      <h3 className="text-xl font-bold text-center mb-3">Check your email</h3>
      <p className="text-center text-gray-600 mb-5">
        We have sent a password recover <br /> instructions to your email.
      </p>
         Didn't receive the email?{" "}
            {resendEnabled ? (
                 <Button
                 label="Resend Email"
                 loading={submitting}
                 onClick={resendEmail}
                 className="w-1/2 md:w-1/2 p-2 font-bold text-xl rounded-xl bg-primary-500 text-white hover:bg-orange-600"
               />
            ) : (
              <span className="text-primary-500">Resend email in {timer} s</span>
            )}
    </div>

  );
};
export default ResendEmailResetForm;
